<template>
  <div class="grid grid-rows-[auto,auto,1fr] gap-1">
    <div class="flex flex-wrap items-center justify-between mt-5">
      <ap-sider-item
        :selected="route.meta.headerType === HEADER_TYPE.SETTINGS"
        class="mb-1 min-h-9 md:min-h-7 font-normal"
        :icon="SettingOutlined"
        :text="$t('settings.people.settings.tab.label')"
        @click="handleSiderItemClick({ name: 'people' })" />
      <ap-sider-item
        class="mb-6 font-normal min-h-9 md:min-h-7"
        :icon="QuestionCircleFilled"
        :text="$t('navigation.help.label')"
        @click="handleHelpCenterClick()" />
      <ap-sider-title
        class="mb-1 min-h-9 md:min-h-7 font-normal"
        :title="$t('navigation.link.label')" />
      <ap-sider-item
        :selected="route.name === 'qrs'"
        class="mb-1 min-h-9 md:min-h-7 font-normal"
        :icon="QrcodeOutlined"
        :text="$t('navigation.content.label')"
        @click="handleSiderItemClick({ name: 'qrs', params: { state: 'all' } })" />
    </div>
    <TheMainLayoutSiderContentProjects />
  </div>
</template>

<script setup>
import { useRoute, useRouter } from "vue-router"
import { QrcodeOutlined, QuestionCircleFilled, SettingOutlined } from "@ant-design/icons-vue"
import { HEADER_TYPE } from "@/interfaces/header.js"
import TheMainLayoutSiderContentProjects from "@/layouts/TheMainLayout/TheMainLayoutSiderContentProjects.vue"

const route = useRoute()
const router = useRouter()

function handleSiderItemClick(routeParams) {
  router.push(routeParams)
}

function handleHelpCenterClick() {
  window.open(import.meta.env.VITE_APP_HELP_CENTER_URL, "_blank")
}
</script>
